import { useCallback } from 'react';

import { useClient } from 'urql';

import { CustomerSessionDocument, CustomerSessionQuery } from './graphql/CustomerSession.generated';

export const useCustomerSession = () => {
  const client = useClient();

  const fetchCustomerSessionSecret = useCallback(async () => {
    const response = await client
      .query<CustomerSessionQuery>(CustomerSessionDocument, { requestPolicy: 'network-only' })
      .toPromise();

    return response.data?.customerPaymentInfo?.paymentSessionId;
  }, [client]);

  return { fetchCustomerSessionSecret };
};
